const numberRoll = () => {

    const countdownElements = document.querySelectorAll('.countdown__scrolltrigger');

    if (countdownElements) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    countdownVisibleAnimation(entry.target.parentNode);
                    observer.unobserve(entry.target);
                }
                
            });
        },{ 
            threshold: 0.75
        });

        countdownElements.forEach((countdownElement) => {
          observer.observe(countdownElement);
        });
    }
}







function countdownVisibleAnimation(countdown){

    gsap.registerPlugin(ScrollTrigger);


    var count = countdown.querySelector('.counts');

    if(count){
        var zero = {val: (count.dataset.number - 20) },
            num = count.dataset.number,
            split = (num + "").split("."),
            decimals = split.length > 1 ? split[1].length : 0;

        gsap.to(zero, {
            val: num,
            duration: 0.75,
            scrollTrigger: countdown,
            toggleActions: 'play reset reverse reset',
            onUpdate: function () {
                count.innerHTML = zero.val.toFixed(decimals);
            }
        });
    }

    if (window.innerWidth < 992) {
        return;
    }


    gsap.fromTo(countdown.querySelector('.countdown__outer-colour'),
        {
            scale: 0,
            opacity:0,
        },
        {
            scrollTrigger: {
                trigger: countdown,
                scrub: true,
                start: "top bottom",
            },
            scale: 2,
            opacity:1,
            transformOrigin: "center"
        }
    );

    gsap.fromTo(countdown.querySelector('.countdown__inner-colour'),
        {
            scale: 0,
            opacity:0,
        },
        {
            scrollTrigger: {
                trigger: countdown,
                scrub: true,
                start: "top bottom",
            },
            scale: 2,
            opacity:1,
            transformOrigin: "center"
        }
    );
}